import React, { useState } from "react";
import PropTypes from "prop-types";
import { FileText, File } from "@phosphor-icons/react";
import { useGetDocumentRequired } from "../../adapters/Requests";
import { viewFileFromS3 } from "../../utils/funtions";
import DocumentViewerModal from "../modals/DocumentViewerModal";

function DocumentUpload({ documents, vacancy }) {
  const DocumentRequirements = useGetDocumentRequired(vacancy);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState({ url: null, name: null });
  const [isLoadingFile, setIsLoadingFile] = useState(false);

  if (DocumentRequirements.isLoading) {
    return <div className="text-xs text-gray-500">Loading documents...</div>;
  }

  const documentsWithRequirements = documents?.map((doc) => {
    const requirementName = DocumentRequirements.data?.documents?.find(
      (req) => req.id === doc.application_document_type_id
    )?.name;

    return { ...doc, requirementName };
  });

  const viewFile = async (fileKey, fileName) => {
    try {
      setIsLoadingFile(true);
      setSelectedFile({ url: null, name: fileName });
      setIsModalOpen(true);
      const signedUrl = await viewFileFromS3(fileKey);
      setSelectedFile({ url: signedUrl, name: fileName });
    } catch (error) {
      console.error("Error fetching file:", error);
      setIsModalOpen(false);
    } finally {
      setIsLoadingFile(false);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedFile({ url: null, name: null });
  };

  return (
    <>
    <div className="bg-white rounded-xl  border border-slate-200 overflow-hidden w-full mt-8">
      <div className="bg-slate-50 px-6 py-3 border-b border-slate-100 flex items-center gap-2">
        <FileText size={16} className="text-slate-500" />
        <h2 className="text-xs font-bold text-slate-700 uppercase tracking-wider">
          Uploaded Documents
        </h2>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {documentsWithRequirements?.map((doc) => (
            <button
              key={doc.id}
              onClick={() => viewFile(doc.document_url, doc.requirementName || "Document")}
              className="flex items-center justify-between p-3 bg-slate-50 border border-slate-200 rounded-lg hover:border-green-300 hover:bg-green-50 transition-all group text-left"
            >
              <div className="flex items-center gap-3 overflow-hidden">
                <div className="bg-white p-1.5 rounded border border-slate-100 group-hover:border-green-200">
                  <FileText className="w-4 h-4 text-slate-400 group-hover:text-green-600" />
                </div>
                <div className="flex flex-col overflow-hidden">
                  <span className="text-xs font-bold text-slate-700 truncate group-hover:text-green-800">
                    {doc.requirementName || "Document"}
                  </span>
                  <span className="text-[10px] text-slate-400 truncate group-hover:text-green-600">
                    Click to view file
                  </span>
                </div>
              </div>
              <File className="w-4 h-4 text-slate-300 group-hover:text-green-500" />
            </button>
          ))}
          {(!documentsWithRequirements ||
            documentsWithRequirements.length === 0) && (
            <div className="col-span-full text-center py-4 text-sm text-slate-400 italic">
              No documents uploaded.
            </div>
          )}
        </div>
      </div>
    </div>

      {/* Document Viewer Modal */}
      <DocumentViewerModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        fileUrl={selectedFile.url}
        fileName={selectedFile.name}
        isLoading={isLoadingFile}
      />
    </>
  );
}

DocumentUpload.propTypes = {
  documents: PropTypes.array,
  vacancy: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DocumentUpload;
